(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function init() {
    var frames = Array.prototype.slice.call(document.querySelectorAll('[data-frame]'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));

    // --- troca de imagem pela trilha de thumbs
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.dataset.thumb;
        frames.forEach(function (f) { f.classList.toggle('hidden', f.dataset.frame !== i); });
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });

    // --- zoom por hover (2x, transform-origin seguindo o mouse)
    // Igual ao ProductImageZoom.tsx: só em dispositivos com hover real.
    if (window.matchMedia('(hover: hover)').matches) {
      document.querySelectorAll('[data-zoom]').forEach(function (frame) {
        var img = frame.querySelector('[data-zoom-img]');
        if (!img) return;

        frame.addEventListener('mousemove', function (e) {
          var r = frame.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width) * 100;
          var y = ((e.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
          img.style.transform = 'scale(2)';
        });
        frame.addEventListener('mouseleave', function () {
          img.style.transform = '';
          img.style.transformOrigin = '';
        });
      });
    }

    // --- lightbox
    var dialog = document.querySelector('[data-lightbox]');
    if (!dialog || !dialog.showModal) return;
    var dialogImg = dialog.querySelector('[data-lightbox-img]');

    document.querySelectorAll('[data-lightbox-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var frame = btn.closest('[data-frame]');
        var img = frame && frame.querySelector('[data-zoom-img]');
        if (!img) return;
        dialogImg.src = img.src;
        dialogImg.alt = img.alt;
        dialog.showModal();
      });
    });

    var close = dialog.querySelector('[data-lightbox-close]');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
(function () {
  function key() {
    return (window.VELU && window.VELU.settings && window.VELU.settings.wishlistKey) || 'velu-wishlist';
  }

  function read() {
    try {
      var raw = localStorage.getItem(key());
      if (!raw) return [];
      return (JSON.parse(raw).state || {}).handles || [];
    } catch (e) { return []; }
  }

  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function card(p) {
    var img = p.featured_image
      ? '<img src="' + p.featured_image + '&width=600" alt="" width="600" height="750" loading="lazy">'
      : '';
    var badge = p.available ? '' : '<span class="product-card__badge">Esgotado</span>';
    return (
      '<div class="product-card' + (p.available ? '' : ' product-card--sold-out') + '">' +
        '<a href="' + p.url + '" class="product-card__media">' + img + badge + '</a>' +
        '<button type="button" class="wishlist-btn" data-wishlist-toggle data-handle="' + p.handle + '" aria-pressed="true" aria-label="Remover dos favoritos">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>' +
        '</button>' +
        '<a href="' + p.url + '" class="product-card__title text-body-md">' + p.title + '</a>' +
        '<span class="product-card__price text-label-sm">' + money(p.price) + '</span>' +
      '</div>'
    );
  }

  function render() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    var handles = read();
    if (!handles.length) {
      grid.hidden = true;
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var found = products.filter(Boolean);
      if (!found.length) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }
      grid.innerHTML = found.map(card).join('');
      grid.hidden = false;
      if (empty) empty.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
  document.addEventListener('velu:wishlist:change', render);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = '1';

    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    if (!track || slides.length < 2) return;

    var index = 0;
    var delay = parseInt(root.dataset.autoplay, 10) || 5000;
    var timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }

    function start() {
      stop();
      timer = window.setInterval(function () { go(index + 1); }, delay);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { go(di); start(); });
    });

    // Pausa no hover, igual ao componente React.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);

    // Mantém os dots em sincronia com swipe manual.
    var raf;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (s, si) {
          var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = si; }
        });
        index = nearest;
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      });
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-carousel]')).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
